import { NgModule }             from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RolUserOutComponent }    from './rolUserOut.component';

const SECURITY_ROUTES: Routes = [
  { path: 'security/roluser', component: RolUserOutComponent }
];

export const ROUTABLE_COMPONENTS = [
];

@NgModule({
  imports: [
    RouterModule.forChild(SECURITY_ROUTES)
  ],
  exports: [
    RouterModule
  ],
  providers: []
})
export class RolUserRoutingModule {}
